<template>
  <div class="app">
    <img class="bg_wrap" src="./../../assets/img/bg0.jpg" mode='scaleToFill'>
    <div class="content_warp">
      <div class="title">
        <img src="./../../assets/img/identity1.png" mode='widthFix'>
      </div>
      <!-- <div class="btn1" @click="identityClick(0)">
        <img src="./../../assets/img/identity2.png" mode='widthFix'>
      </div> -->
      <div class="btn2" @click="identityClick(0)">
        <img src="./../../assets/img/identity3.png" mode='widthFix'>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isinfo:false,//是否已经填写过信息
    }
  },
  methods:{
    identityClick(type){
      this.isinfo = this.$store.state.status.msg?true:false;
      console.log(this.isinfo)
      if(this.isinfo){
        this.$router.push(`/pages/answer/main`);
        // this.$router.replace(`/pages/answer/main`);
      }else{
        // this.$router.push(`/pages/info/main?type=${type}`);
        this.$router.push({ name: "info" })
        // this.$router.replace(`/pages/answer/main`);
        // this.$router.replace(`/pages/info/main?type=${type}`);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app{
  min-height: 100vh;
  position: relative;
  .bg_wrap{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
  }
  .content_warp{
    position: relative;
    .title{
      padding-top: 1.75rem;
      img{
        width: 4.14rem;
        height: 3.69rem;
        display: block;
        margin: auto;
        // margin-left: 45rpx;
      }
    }
    .btn1,.btn2{
      width: 4.98rem;
      margin: .53rem auto 0;
    }
    .btn1{
      img{
        width: 5.66rem;
        height: 2.61rem;
      }
    }
    .btn2{
      
      img{
        width: 4.98rem;
        height: 1.14rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Identity/index.vue